// import the required animation functions from the angular animations module
import {trigger, state, animate, transition, style, query, stagger, animateChild} from '@angular/animations';

export const cardEntranceFromAbove =

  trigger('cardEntranceFromAbove', [
    transition('* => *', [ // each time the binding value changes
      query(':enter .card', [style({ opacity: 0, transform: 'translateY(-20px)' })], {optional: true}),
      query(':enter .card', [
        stagger(40, [
          animate('.3s ease', style({ opacity: 1, transform: 'translateY(0px)' })),
          animateChild()
        ])
      ], {optional: true}),
      animateChild()
    ])
  ]);

export const cardEntranceFromLeft =
  trigger('cardEntranceFromLeft', [
    transition('* => *', [ // each time the binding value changes
      query(':enter .card', [style({ opacity: 0, transform: 'translateX(-20px)' })], {optional: true}),
      query(':enter .card', [
        stagger(40, [
          animate('.3s ease', style({ opacity: 1, transform: 'translateX(0px)' }), ),
          animateChild()])], {optional: true}),
      query(':leave .card', [
        animate('.3s ease',style({ opacity: 0, transform: 'translateY(-10px)' }))
      ],{optional: true}),
      animateChild()
    ])
  ]);
